module.exports = __webpack_public_path__ + "img/Taal.3e32dbeb.svg";